/*
 * FromConstants
 */

export const PRINT_OFFER = 'ideal/components/Froms/PRINT_OFFER';

export const SEARCH_CUSTOMER = 'ideal/components/Froms/SEARCH_CUSTOMER';
export const CUSTOMER_RECEIVED = 'ideal/components/Froms/CUSTOMER_RECEIVED';
export const RESET_RECEIVED = 'ideal/components/Froms/RESET_RECEIVED';

